import { useEffect, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import TNavbar from "../../../components/TNavbar";

const CookingMode = ({steps, display, setCookingModeDisplay}) => {
  const [stepNumber, setStepNumber] = useState(1)
  const [micIcon, setMicIcon] = useState(["icon-iconmicrophone-mute"]);

  const backStep = () => {
    resetTranscript();
    if (stepNumber -1 > 0) {
      setStepNumber(stepNumber -1)
    }
  };

  const forwardStep = () => {
    resetTranscript();
    if (stepNumber +1 <= steps.length) {
      setStepNumber(stepNumber +1)
    }
  };

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

  useEffect(() => {
    if (display === 'block') {
      if (isMicrophoneAvailable) {
        setStepNumber(1)
        SpeechRecognition.startListening({ language: "ar-SA", continuous: true });
        setMicIcon(["icon-iconmicrophone"]);
      }
    } else {
      setStepNumber(1)
      SpeechRecognition.stopListening();
    }
  }, [display]);

  useEffect(() => {
    if (transcript.includes("بعدي") || transcript.includes("بعد") || transcript.includes("بع") || transcript.includes("باقي") || transcript.includes("فادي") || transcript.includes("عادي")) {
      forwardStep();
    } else if (transcript.includes("قبلي") || transcript.includes("قابلي") || transcript.includes("قبل") ) {
      backStep();
    }
  }, [transcript]);

  const handleMic = () => {
    // Request microphone permission
    if (listening) {
      SpeechRecognition.stopListening();
      setMicIcon(["icon-iconmicrophone-mute"]);
    } else {
      SpeechRecognition.startListening({ language: "fa-IR", continuous: true });
      if (isMicrophoneAvailable) {
        setMicIcon(["icon-iconmicrophone"]);
      }
    }
  };
 
  const backToCard = () => {
    // SpeechRecognition.stopListening();
    setCookingModeDisplay('none')
  };

  return (
    <div className="overlay-cooking max-width800" style={{display:display}}>
      <TNavbar
        title=""
        rbuttonIcon={["icon-iconclose"]}
        rbackground={["rectangle"]}
        rfunction={backToCard}
        lbuttonIcon={micIcon}
        lbackground={["none"]}
       // lfunction={handleMic}
      />
      <div className="main-container">
        <div>
          {/* <div>{transcript}</div> */}
          {steps && steps[stepNumber - 1] && (
            <div>
              <div className="big-1">{stepNumber}</div>
              <div className="heading-1 rightAlign marginTop5">
                {steps[stepNumber - 1].step_description}
              </div>
            </div>
          )}
        </div>
        <div className="cook-nav">
        <div className="subject-1 yekan b-white">بگی "بعدی"، میره بعدی! برای قبلی هم همینطور</div>
        <div className="spc-between">
          <button onClick={backStep} className="heading-2 purple-1 b-grey-5">
            قبلی
          </button>
          <button onClick={forwardStep} className="heading-2">
            بعدی
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default CookingMode;
